<template>
    <div>
        <p>
            Nyní, prosím, potvrďte přístup DSchránce do Vaší schránky. Vložte naše ID jako hostovanou spisovou službu na adrese:
            <a class="underline" href="https://www.mojedatovachranka.cz/portal/ISDS/nastaveni/extapp/hsssluzby">https://www.mojedatovachranka.cz/portal/ISDS/nastaveni/extapp/hsssluzby</a>
            <img src="/img/hspis2.png" alt="guide">
        </p>

        <p class="mt-4">
            ID (zkopírujete kliknutím): <br>
            <code @click="copyID" :class="copying ? 'text-blue-500' : 'text-black'" class="bg-gray-50 p-1 font-bold cursor-pointer transition-colors"> {{ id }} </code>
        </p>
    </div>
</template>

<script>
export default {
    name: "HspisPopupSecond",
    data(){
        return {
            copying: false,
            id: this.$page.props.hspisID
        }
    },
    methods: {
        copyID(){
            this.copying = true;
            setTimeout( () => { this.copying = false; }, 100);
            navigator.clipboard.writeText(this.id);
        }
    }
}
</script>

<style scoped>

</style>
